export const locale = {
    lang: 'en',
    data: {
        NAV: {
            APPLICATIONS: 'Menu Principal',
            MODULES: 'Módulos',
            PAINEL        : {
                TITLE: 'Painel',
            },
            CARGA        : {
                TITLE: 'Carga de Documentos',
            },
            ADMIN        : {
                TITLE: 'Administrador',
            },
            SUPERADMIN        : {
                TITLE: 'SuperAdmin',
            },
            COORDENADOR  : {
                TITLE: 'Coordenador',
            },
            ARQUIVISTA        : {
                TITLE: 'Arquivista',
            },
            TAREFA        : {
                TITLE: 'Tarefas',
                ADMINISTRATIVAS: {
                    TITLE: 'Administrativas'
                }
            },
            PROTOCOLO        : {
                TITLE: 'Protocolo (Novo NUP)',
                ADMINISTRATIVO: {
                    TITLE: 'Administrativo'
                },
            },
            PESQUISA        : {
                TITLE: 'Pesquisa'
            },
            RELATORIOS        : {
                TITLE: 'Relatórios'
            },
            RELATORIO        : {
                TITLE: 'Relatórios SUPP'
            },
            OFICIO : {
                TITLE: 'Ofícios'
            },
            PROTOCOLO_EXTERNO : {
                TITLE: 'Protocolo'
            },
            CAIXA_EMAIL: {
                TITLE: 'Caixa de E-mail'
            }, // ALTERADO PELA PGE-RS
            BD0 : {
                TITLE: 'Relatórios BD-0'
            },
            ADVOGADOS : {
                TITLE: 'Advogados'
            },
            TODAS_TAREFA: {
                TITLE: 'Todas as tarefas'
            }
        }
    }
};
